import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import PageHeader from "../components/PageHeader";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import InputField from "../../../FinalForm/InputField";
import EmailField from "../../../FinalForm/EmailField";
import SelectField from "../../../FinalForm/SelectField";
import {Form} from "react-final-form";
import {apiGetUser, apiPostCreateUser, apiPutUpdateUser} from "./Actions";
import {FiSave} from "react-icons/fi";
import {FilterButton} from "../components/Button";
import {FormCard} from "../components/FormCard";

const AccessUserForm = () => {
    let [loading, setLoading] = useState(false);
    let [saving, setSaving] = useState(false);
    let [data, setData] = useState(null);

    const {id} = useParams();
    const navigate = useNavigate();
    let user = useSelector((state) => state.user);

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const getData = () => {
        if (id) {
            setLoading(true);
            apiGetUser(user.activeAreal.id, id, (data) => {
                setData(data);
                setLoading(false);
            }, (err) => {
                setLoading(false);
                handleError(err);
                navigate("/access/user");
            });
        }
    };

    const handleError = (err) => {
        let error = "Nepodařilo se načíst data o uživateli.\n";
        if (typeof err.data === "string" || err.data instanceof String) {
            switch (err.data) {
                case "USER_NOT_FOUND": error += "Uživatel nebyl nalezen."; break;
                case "UNKNOWN_ERROR":
                default: error += "Neznámá chyba.";
            }
        } else {
            if (err.data.password) { error += " Heslo"; error += getErrorMessage(err.data.password); }
            if (err.data.email) { error += " Email"; error += getErrorMessage(err.data.email); }
            if (err.data.name) { error += " Jméno"; error += getErrorMessage(err.data.name); }
            if (err.data.competency) { error += " Oprávnění"; error += getErrorMessage(err.data.competency); }
        }
        Toast.error(error);
    };

    const getErrorMessage = (type) => {
        switch (type) {
            case "INVALID_LENGTH": return " má nepovolenou délku.";
            case "NULL":
            case "EMPTY": return " je prázdný/é.";
            default: return " neznámá chyba.";
        }
    };

    const onSubmit = (values) => {
        if (!user?.user?.rights?.enigooTurniketsEdit) return;
        setSaving(true);
        if (id) {
            apiPutUpdateUser(user.activeAreal.id, id, values, (data) => {
                setData(data);
                setSaving(false);
                Toast.success("Úspěšně uloženo.");
            }, (err) => {
                setSaving(false);
                handleError(err);
            });
        } else {
            apiPostCreateUser(user.activeAreal.id, values, (data) => {
                setData(data);
                setSaving(false);
                navigate("/access/user/detail/" + data.id);
                Toast.success("Úspěšně uloženo.");
            }, (err) => {
                setSaving(false);
                handleError(err);
            });
        }
    };

    return (
        <>
            <PageHeader crumbs={[{label:"Interní uživatelé", to:"/access/user"}, {label: id ? "Upravit interního uživatele" : "Vytvořit interního uživatele"}]}/>

            {loading ? <DefaultLoader text={"Načítám data uživatele..."}/> : (
                <Form onSubmit={onSubmit} initialValues={data}
                    render={({handleSubmit}) => (
                        <>
                            <FormCard>
                                <InputField label={"Jméno"} name={"name"} maxLength={50} isMandatory={false} inputType={"text"}/>
                                <EmailField name={"email"} label={"Email"} isMandatory={true} maxLength={50}/>
                                <InputField label={"Heslo"} name={"password"} maxLength={50} minLength={8} isMandatory={!id} inputType={"password"}/>
                                <SelectField name={"competency"} options={[
                                    {label: "Administrátor", value: "admin"},
                                    {label: "Bežný uživatel", value: "user"}
                                ]} label={"Právo"} isMandatory={true}/>
                            </FormCard>
                            {user?.user?.rights?.enigooTurniketsEdit && (
                                <FilterButton type="button" onClick={handleSubmit} loading={saving} text="Uložit" icon={<FiSave size={12}/>} fullWidth/>
                            )}
                        </>
                    )}
                />
            )}
        </>
    );
};
export default AccessUserForm;
